import { hasPermission } from "byzantine/src/dbbl/businessLogic/modules/permissions/utils";
import { BUSINESS } from "byzantine/src/dbbl/businessLogic/modules/permissions/constants";

import { useCurrentUser } from "../../../../components/contexts/CurrentUserContext";

export const useCanWriteReceipts = (): boolean => {
  const { currentUser } = useCurrentUser();
  if (!currentUser) return false;
  return hasPermission(
    currentUser.business_permissions,
    BUSINESS.WRITE.TRANSACTION
  );
};

export default useCanWriteReceipts;
